import styled, { css } from 'styled-components';

import {
    FormHelp,
    Input,
} from '@zillow/constellation';

export const StyledInput = styled(Input)`
    ${props => (props.duplicateError && css`
        & {
            caret-color: #055E16; /* use green600 after constellation v8 migration*/

            &,
            &[disabled],
            &:hover:hover, /* hover duplicated to override :not([disabled]) */
            &:active:active, /* hover duplicated to override :not([disabled]) */
            &:focus {
                border-color: #055E16; /* use green600 after constellation v8 migration*/
            }
        }
    `)}
`;

export const StyledFormHelp = styled(FormHelp)`
    ${props => (props.duplicateError && css`
        & {
            color: #055E16; /* use green600 after constellation v8 migration*/
        }
    `)}
`;
